{
    "MakeCallTitle": "Effettuare una chiamata",
    "MakeCallTooltip": "Effettuare una chiamata al dispositivo corrispondente.",
    "IttTitle": "Inchiesta Trasferimento",
    "IttTooltip": "Effettuare una chiamata di consultazione al dispositivo corrispondente per avviare un'operazione di trasferimento di chiamata.",
    "CallDetailsTitle": "Chiama i dettagli...",
    "CallDetailsTooltip": "Visualizza informazioni dettagliate sulla chiamata in una nuova finestra.",
    "CompleteTransferTitle": "Trasferimento completo",
    "CompleteTransferTooltip": "Completa l'operazione di trasferimento della chiamata di richiesta avviata in precedenza spostando la chiamata in attesa verso la destinazione chiamata in precedenza.",
    "PickupThisCallTitle": "Rispondi a questa chiamata",
    "PickupThisCallTooltip": "Rispondere immediatamente a questa chiamata di allarme al proprio interno.",
    "StealThisCallTitle": "Ruba questa chiamata",
    "StealThisCallTooltip": "Spostare la chiamata attualmente in risposta o in avviso sul proprio interno, dove squillerà successivamente.",
    "SendToCallTitle": "Inviare la chiamata a...",
    "SendToCallTooltip": "Sposta la chiamata attualmente in risposta o in avviso a una nuova destinazione specifica dove squillerà successivamente.",
    "MonitorTitle": "Monitor",
    "MonitorTooltip": "Opzioni di monitoraggio dei dispositivi e delle chiamate.",
    "SilentMonitorTitle": "Monitor silenzioso",
    "SilentMonitorTooltip": "Avvia una sessione di monitoraggio silenzioso con la chiamata attualmente risposta sul dispositivo.",
    "ForcedIntrudeTitle": "Intrusione forzata",
    "ForcedIntrudeTooltip": "Si intromette (barge) nella chiamata in corso sul dispositivo corrispondente, in modo da poter partecipare attivamente alla chiamata.",
    "RecordCallTitle": "Registrare la chiamata",
    "RecordCallTooltip": "Eseguire un'operazione di registrazione di una chiamata in diretta sulla chiamata correntemente risposta sul dispositivo.",
    "RegisterCallbackTitle": "Registro Callback",
    "RegisterCallbackTooltip": "Visualizzare un messaggio sul dispositivo corrispondente, ricordando di richiamare il proprio interno.",
    "AgentSignInOutTitle": "Registrazione\/uscita dell'agente",
    "AgentSignInOutTooltip": "Accesso\/uscita dall'estensione.",
    "SignInTitle": "Accedi...",
    "SignInTitleAllGroups": "Accesso (Tutti i gruppi)",
    "SignInTooltip": "Segnalare il dispositivo o l'agente corrispondente, rendendolo \"in servizio\" e potenzialmente disponibile a rispondere alle chiamate ACD.",
    "SignOutTitle": "Esci",
    "SignOutTitleAllGroups": "Uscita (tutti i gruppi)",
    "SignOutTooltip": "Segnalare l'uscita del dispositivo o dell'agente corrispondente, rendendolo \"fuori servizio\" e non disponibile a rispondere alle chiamate ACD.",
    "GroupsTitle": "Gruppi",
    "GroupsTooltip": "Scegliere i gruppi ACD a cui l'agente è iscritto.",
    "NoGroupsTooltip": "Non sono stati trovati gruppi ACD per questo agente.",
    "GroupsAllTitle": "[All]",
    "SetDndOnTitle": "Impostare il DND su On",
    "SetDndOnTooltip": "Attivare l'opzione \"non disturbare\" sul dispositivo, per renderlo non disponibile a ricevere chiamate.",
    "SetDndOffTitle": "Impostare il DND su Off",
    "SetDndOffTooltip": "Disattivare la funzione \"non disturbare\" sul dispositivo, per renderlo disponibile a ricevere le chiamate in entrata.",
    "SetStatusTitle": "Impostare lo stato",
    "SetStatusTooltip": "Impostare lo stato ACD per questo agente.",
    "AvailableTitle": "Disponibile",
    "AvailableTooltip": "Impostare l'agente nello stato Disponibile, che lo renderà disponibile a rispondere alle chiamate ACD.",
    "DndTitle": "DND",
    "DndTooltip": "Impostare l'agente nello stato DND, che lo renderà non disponibile a rispondere alle chiamate ACD.",
    "WrapUpTitle": "Conclusione",
    "WrapUpTooltip": "Impostare l'agente nello stato Wrap-Up, che lo renderà non disponibile a rispondere alle chiamate ACD.",
    "NotAvailableTitle": "Non disponibile",
    "NotAvailableTooltip": "Impostare l'agente nello stato ACD Non disponibile e specificare inoltre un codice di motivazione, che può essere utilizzato per identificare il motivo per cui l'agente corrispondente non è disponibile a rispondere alle chiamate ACD.",
    "NoReasonTitle": "[Nessuna ragione]",
    "NoReasonTooltip": "Impostare l'agente nello stato ACD Non disponibile, senza alcun motivo.",
    "AdvancedTooltip": "Azioni avanzate di controllo delle chiamate.",
    "AnswerCallTitle": "Risposta alla chiamata",
    "AnswerCallTooltip": "Rispondere alla chiamata in corso.",
    "ClearCallTitle": "Chiamata libera",
    "ClearCallTooltip": "Termina la chiamata corrispondente.",
    "AdminOnlyTitle": "Solo amministratore",
    "AdminOnlyTooltip": "Azioni solo per l'amministratore.",
    "DeletePhantomTitle": "Cancellare la chiamata fantasma",
    "DeletePhantomTooltip": "Costringe l'applicazione a smettere di modellare la chiamata corrispondente come attiva, il che può influire negativamente sulle statistiche delle chiamate.",
    "RowOptions_AdvancedTitle": "Avanzato",
    "NAME": "RowOptions",
    "SetAccountCodeMenuOptionTitle": "Impostare il codice del conto",
    "SetAccountCodeMenuOptionTooltip": "Imposta il codice del conto per questa chiamata.",
    "NoAccountCodeMenuOptionTitle": "[Nessun codice conto]",
    "NoAccountCodeMenuOptionTooltip": "Disattivare il codice del conto",
    "AccountCodeMenuOptionTooltip": "Impostare il codice conto \"{}\" per la chiamata."
}